<agpr-dialog-container
    class="agpr-libraryMoveDialog"
    [id]="'libraryMoveDialog'"
    [heading]="'Common.contentLibrary.manageDialog.library.Folder.Move'"
    (close)="cancel()"
>
    <div
        id="libraryMoveDialog_content"
        class="agpr-libraryMoveDialog-content"
    >
        <agpr-autocomplete
            [id]="'librarySelection_input'"
            [dropdown]="true"
            label='Common.lhp.libraryMoveDialog.autocomplete.choose.library'
            placeholder='Common.lhp.libraryMoveDialog.autocomplete.placeholder'
            labelField="name"
            [suggestions]="groupOptions"
            [(ngModel)]="selectedOption"
            [clearOnBlur]="false"
            [required]="true"
            [customOptions]="autocompleteCustomOptions"
        >
        </agpr-autocomplete>

        <div
            id="libraryMoveDialog_message"
            class="agpr-libraryMoveDialog-message"
        >
            {{'Common.lhp.libraryMoveDialog.autocomplete.choose.files' | localize : {selectedFilesCount: selectedItemsCount} }}
        </div>
    </div>
    <ng-template #footerLeft>
        <agpr-button
            [id]="'libraryMoveDialog_cancelButton'"
            (click)="cancel()"
            [label]="'cancel'"
            [style]="buttonStyle.secondary"
        ></agpr-button>
    </ng-template>
    <ng-template #footerRight>
        <agpr-button
            [id]="'libraryMove_okButton'"
            (click)="ok()"
            label="Move"
            ariaLabel='Common.contentLibrary.files.move'
            [disabled]="!selectedOption"
            [style]="buttonStyle.primary"
            [tooltip]="(!selectedOption) ? 'Common.lhp.libraryMoveDialog.okButton.disabled.tooltip' : ''"
        ></agpr-button>
    </ng-template>
</agpr-dialog-container>
